import { getItem, createItem, deleteItem, ItemRequestStatus } from "./generics";
import TaxPayerAssets, { TemplateField } from "../models/tax-payer-assets";

export type TaxPayerAssetField = "signaturePath" | "logoPath" | TemplateField;

export const getTaxPayerAssets = (): Promise<
  ItemRequestStatus<TaxPayerAssets>
> => getItem<TaxPayerAssets>("/tax_payer_assets/");

export const createSignatureUploadUrl = (
  fileName: string,
): Promise<ItemRequestStatus<{ url: string; uploadId: string }>> =>
  createItem<{ url: string; uploadId: string }, { fileName: string }>(
    "/tax_payer_assets/create_signature_url/",
    { fileName },
  );

export const createLogoUploadUrl = (
  fileName: string,
): Promise<ItemRequestStatus<{ url: string }>> =>
  createItem<{ url: string }, { fileName: string }>(
    "/tax_payer_assets/create_logo_url/",
    { fileName },
  );

export const createTemplateUploadUrl = (
  field: TemplateField,
  fileName: string,
): Promise<ItemRequestStatus<{ url: string }>> =>
  createItem<{ url: string }, { field: TemplateField; fileName: string }>(
    "/tax_payer_assets/create_template_url/",
    { field, fileName },
  );

export const getSignatureUrl = (): Promise<
  ItemRequestStatus<{ url: string }>
> => getItem<{ url: string }>("/tax_payer_assets/signature_url/");

export const getLogoUrl = (): Promise<ItemRequestStatus<{ url: string }>> =>
  getItem<{ url: string }>("/tax_payer_assets/logo_url/");

export const getTemplateUrl = (
  field: TemplateField,
): Promise<ItemRequestStatus<{ url: string }>> =>
  getItem<{ url: string }>(
    "/tax_payer_assets/template_url/",
    new Map([["field", field]]),
  );

export const deleteTaxPayerAsset = (
  field: TaxPayerAssetField,
): Promise<ItemRequestStatus<{ field: TaxPayerAssetField }>> =>
  deleteItem<{ field: TaxPayerAssetField }>("/tax_payer_assets/asset/", {
    field,
  });

export const updateSignaturePassword = (
  password: string,
  stagedSignature?: { uploadId: string; fileName: string },
): Promise<
  ItemRequestStatus<{
    signatureExpirationDate: string;
    signaturePath?: string;
  }>
> =>
  createItem<any>("/tax_payer_assets/update_signature_password/", {
    password,
    ...stagedSignature,
  });
